<template>
  <!-- 修改密码 -->
  <div class="app-container">
    <ContainerFull>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="用户名" prop="loginName">
          <el-input type="text" v-model="loginName" readonly></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" show-password clearable></el-input>
        </el-form-item>
      </el-form>

      <template v-slot:footer>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="$goBack()">关闭</el-button>
      </template>
    </ContainerFull>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ContainerFull from '@/components/ContainerFull';

export default {
  components: { ContainerFull },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        callback();
      }
    };

    var validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      loginName: '',
      ruleForm: {
        pass: '',
        checkPass: ''
      },
      rules: {
        pass: [{ required: true, validator: validatePass2, trigger: 'blur' }],
        checkPass: [{ required: true, validator: validatePass3, trigger: 'blur' }]
      }
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.loginName = this.userInfo.loginName;
  },
  methods: {
    //修改密码
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$post('user/changePassword', { loginName: this.loginName, password: this.ruleForm.pass }).then(res => {
            if (res.status == 0) {
              this.$message.success('密码修改成功！');
              this.$refs[formName].resetFields();
            } else {
              this.$refs[formName].resetFields();
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form {
  width: 600px;
  margin: 40px auto;
}
</style>
